export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-100 overflow-hidden pt-[72px]"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/60 via-transparent to-background-100/80 z-[1]"></div>

      <div className="relative z-[2] w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-4 py-1.5 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full mb-6">
              <i className="ri-fire-line text-sm w-3.5 h-3.5 flex items-center justify-center"></i>
              每日凌晨更新
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-black text-foreground-950 leading-tight mb-4">
              黑料视频
              <span className="block text-primary-500">全网最狠吃瓜基地</span>
              <span className="block text-xl sm:text-2xl md:text-3xl font-bold text-foreground-600 mt-2">
                拒绝官腔，只爆猛料，传送门不迷路
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-8">
              每日整理明星八卦、网红黑料、暴走视频合集。从娱乐圈内幕到社交媒体翻车现场，一手猛料全天候追踪。
              凌晨准时更新吃瓜传送门，拒绝水军洗白，不打官腔，只给真瓜。点击直达最新内幕现场，做全网最清醒的吃瓜群众。
            </p>

            <div className="flex items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-primary-500">5000+</div>
                <div className="text-xs text-foreground-500 mt-1">条黑料收录</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-primary-500">24h</div>
                <div className="text-xs text-foreground-500 mt-1">实时追踪</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-primary-500">100%</div>
                <div className="text-xs text-foreground-500 mt-1">直发现场</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => scrollTo('#ranking')}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 text-sm md:text-base font-bold rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer border-0"
              >
                立即吃瓜
                <i className="ri-arrow-right-line text-lg w-4 h-4 flex items-center justify-center"></i>
              </button>
              <button
                onClick={() => scrollTo('#updates')}
                className="inline-flex items-center gap-2 px-8 py-3.5 border-2 border-foreground-300 text-foreground-800 text-sm md:text-base font-semibold rounded-full hover:border-foreground-500 transition-all whitespace-nowrap cursor-pointer bg-transparent"
              >
                查看最新快讯
                <i className="ri-time-line text-lg w-4 h-4 flex items-center justify-center"></i>
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative w-full aspect-[4/5] md:aspect-[5/4] rounded-2xl overflow-hidden bg-gradient-to-br from-primary-200/60 via-primary-100/40 to-accent-200/50">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20composition%20with%20overlapping%20irregular%20rounded%20rectangles%20in%20hot%20pink%20and%20deep%20crimson%20tones%20on%20dark%20charcoal%20background%2C%20editorial%20magazine%20aesthetic%2C%20bold%20graphic%20design%2C%20dynamic%20energy%2C%20grunge%20texture%20overlay%2C%20high%20contrast%2C%20modern%20street%20culture%20vibe%2C%20no%20text%20or%20lettering&width=800&height=1000&seq=hero-main-visual-01&orientation=portrait"
                alt="黑料视频品牌主视觉 - 抽象几何图形组合"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/30 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}